module.exports = __webpack_public_path__ + "static/media/hyundai-01.52a12085.png";